import React, { Fragment, Component } from 'react';
import { Tooltip } from '@gx-design/tooltip';
import { Icon } from '@gx-design/icon';
import PropTypes from 'prop-types';
import classNames from 'classnames';

class InputComponent extends Component {
    static propTypes = {
        label: PropTypes.string,
        id: PropTypes.string.isRequired,
        className: PropTypes.string,
        onChange: PropTypes.func,
        onUpdate: PropTypes.func,
        type: PropTypes.string,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        validate: PropTypes.func,
    };

    state = {
        value: this.props.defaultValue || '',
    };

    get isControlled() {
        return 'value' in this.props;
    }

    get value() {
        return this.isControlled ? this.props.value : this.state.value;
    }

    get name() {
        return this.props.name || this.props.id;
    }

    changeHandler = evt => {
        this.props.onChange && this.props.onChange(evt.target.value);
        this.props.onUpdate && this.props.onUpdate();

        if (!this.isControlled) {
            this.setState({ value: evt.target.value });
        }
    };

    render() {
        let {
            label,
            id,
            className,
            errorClassName,
            defaultValue,
            invalid,
            onUpdate,
            required,
            showRequiredSymbol,
            innerRef,
            type,
            info,
            ...other
        } = this.props;

        if (other.hasOwnProperty('validate')) {
            delete other['validate'];
        }

        if (other.hasOwnProperty('requiredMessage')) {
            delete other['requiredMessage'];
        }

        if (other.hasOwnProperty('showRequiredSymbol')) {
            delete other['showRequiredSymbol'];
        }

        if (other.hasOwnProperty('info')) {
            delete other['info'];
        }

        if (other.hasOwnProperty('errorClassName')) {
            delete other['errorClassName'];
        }

        if (other.hasOwnProperty('status')) {
            delete other['status'];
        }

        if (other.hasOwnProperty('callback')) {
            delete other['callback'];
        }

        return (
            <div className="gx-input-wrapper">
                {label ? (
                    <Fragment>
                        <label htmlFor={id} invalid={`${invalid}`} className="gx-label">
                            {label}
                            {showRequiredSymbol ? (
                                <span className="gx-label__required">*</span>
                            ) : null}
                        </label>
                        {info ? (
                            <span className="gx-tip">
                                <Tooltip text={info}>
                                    <Icon className="gx-icon--info" name="info-circle--active" />
                                </Tooltip>
                            </span>
                        ) : null}
                    </Fragment>
                ) : null}
                <input
                    {...other}
                    id={id}
                    ref={innerRef}
                    type={type}
                    name={this.name}
                    className={classNames([
                        'gx-input',
                        className,
                        errorClassName,
                    ])}
                    value={this.value || ''}
                    onChange={this.changeHandler}
                />
            </div>
        );
    }
}

export const Input = React.forwardRef((props, ref) => (
    <InputComponent innerRef={ref} {...props} />
));
